/** Message for a failed jQuery $.ajax call: the backend reason when there is one. */
export function errorMessageFromAjax(jqXHR: any): string {
  if (jqXHR == null) {
    return 'Error inesperado';
  }

  if (jqXHR.status === 0) {
    return 'No se pudo contactar al servidor';
  }

  const body = jqXHR.responseJSON;

  if (body != null) {
    // 400 responses carry the failed field validations, the rest only a message.
    if (body.errors != null && body.errors.length > 0) {
      return body.errors.join(', ');
    }
    if (body.message) {
      return body.message;
    }
  }

  return 'Error ' + jqXHR.status + ': la operación no se completó';
}
